<template>
    <div class="payment-record-list">
        <!--        <b-row class="mt-3">-->
        <!--            <b-col>-->
        <!--                <b-input :placeholder="$t('search')"-->
        <!--                         v-model="searchInput"></b-input>-->
        <!--            </b-col>-->
        <!--        </b-row>-->
        <b-row class="mt-3">
            <b-col>
                <b-table id="payment-record-list-table"
                         hover
                         responsive
                         stacked="lg"
                         :items="paymentRecords"
                         :fields="fields"
                         :current-page="currentPage"
                         :per-page="perPage">
                    <!--                    <template v-slot:cell(action)="data">-->
                    <!--                        <font-awesome-icon icon="calendar-check"-->
                    <!--                                           v-if="data.item.status === 1 && !data.item.checkin_time"-->
                    <!--                                           @click="checkinBooking(data.item)"></font-awesome-icon>-->
                    <!--                        <font-awesome-icon icon="calendar-times"-->
                    <!--                                           v-if="data.item.status === 1 && data.item.checkin_time"-->
                    <!--                                           @click="uncheckinBooking(data.item)"></font-awesome-icon>-->
                    <!--                        <font-awesome-icon icon="trash"-->
                    <!--                                           v-if="data.item.status === 1"-->
                    <!--                                           @click="cancelBooking(data.item)"></font-awesome-icon>-->
                    <!--                    </template>-->
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-pagination
                        v-model="currentPage"
                        :total-rows="paymentRecords.length"
                        :per-page="perPage"
                ></b-pagination>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEdit, faSearch, faCalendarCheck, faCalendarTimes} from '@fortawesome/free-solid-svg-icons'
    import {DateTime} from 'luxon'

    library.add(faEdit, faSearch, faCalendarCheck, faCalendarTimes);

    export default {
        name: 'PaymentRecordList',
        props: {
            userId: String,
            status: String,
            title: String,
            toDate: String,
            fromDate: String,
            onSelect: Function,
        },
        data() {
            let v = this;
            return {
                searchInput: null,
                paymentRecords: [],
                fields: [
                    {
                        key: 'create_at', label: this.$t('admin_payment.create_at'),
                        sortable: true, sortByFormatted: true,
                        formatter: (value, key, item) => {
                            return DateTime.fromISO(item.create_at).toFormat('yyyy-MM-dd HH:mm');
                        },
                    },
                    // {
                    //     key: 'account', label: this.$t('admin_payment.account'),
                    //     formatter: (value, key, item) => {
                    //         return item.account.name;
                    //     },
                    // },
                    {
                        key: 'payment_type', label: this.$t('admin_payment.payment_type'),
                        sortable: true, sortByFormatted: true,
                        formatter: (value, key, item) => {
                            return this.$t('payment_type.' + item.payment_type);
                        },
                    },
                    {
                        key: 'payment_method', label: this.$t('admin_payment.payment_method'),
                        sortable: true, sortByFormatted: true,
                        formatter: (value, key, item) => {
                            return this.$t('payment_method.' + item.payment_method);
                        },
                    },

                ],
                currentPage: 1,
                perPage: 20,
            }
        },
        mounted() {
            this.getPaymentRecords();
        },
        computed: {
            filteredRecords() {
                let filteredBookings = this.bookings;
                let v = this;

                if (this.status) {
                    let results = [];
                    filteredBookings.forEach(function (booking) {
                        if (booking.status == v.status) {
                            results.push(booking);
                        }
                    });

                    filteredBookings = results;
                }

                if (this.searchInput) {
                    let filteringFields = [
                        'reference_number', 'second_contact_number',
                        'account.name', 'account.email', 'account.username',
                    ];

                    let results = [];

                    let input = this.searchInput.toLowerCase();
                    filteredBookings.forEach(function (booking) {
                        if (_.some(filteringFields, function (path) {
                            let value = v.$resolve(booking, path);
                            return value && value.toString().toLowerCase().indexOf(input) !== -1
                        })) {
                            results.push(booking);
                        }
                    });

                    filteredBookings = results;
                }
                return filteredBookings;
            },
        },
        watch: {
            userId(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.getBookings();
                }
            },
            fromDate(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.getBookings();
                }
            },
            toDate(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.getBookings();
                }
            },
        },
        methods: {
            getPaymentRecords() {
                this.$callAPI('payment/admin/payment_record/', {
                    user_id: this.userId,
                }, function (response) {
                    this.paymentRecords = response.body.records;
                });
            },
        },
    }
</script>

<style lang="less">
    .payment-record-list {
        .fa-search, .fa-check, .fa-trash, .fa-calendar-check, .fa-calendar-times {
            border-radius: 10px;
            font-size: 2em;
            padding: 5px;
            cursor: pointer;

            &:hover {
                background-color: black;
                color: white;
            }
        }
    }
</style>
